import axios from 'src/utils/axios';
import { AxiosResponse } from 'axios';
import { SurveyFile } from 'src/types/Questionnaire/QuestionnaireTypes';

export default class DeletedDocumentsService {
  /**
   * Fetch all deleted files for a certification
   */
  public static fetchDeletedFiles = async (
    certificationId: number
  ): Promise<AxiosResponse<SurveyFile[]>> => {
    return axios.get(`/certification/certification/${certificationId}/trash/`);
  };

  /**
   * Restore a deleted file
   */
  public static restoreFile = async (
    fileId: number
  ): Promise<AxiosResponse> => {
    return axios.post(`/questionnaire/survey_file/${fileId}/restore_file/`);
  };
}
